<div class="document-list-item">
  <div class="document-list-item-content">
    <div class="document-list-item-content-title">

      <ev-file-button [url]="documentUrl" [link]="true">
        <i class="fa fa-file-pdf-o"></i>
        <strong>
          {{ date }}
        </strong> - {{ fileName }}
      </ev-file-button>

    </div>

    @if (item.content) {
      <div class="document-list-item-content-text" [innerHTML]="item.content">
      </div>
    }

    <div class="document-list-item-content-tags">
      @for (category of item.categories; track category) {
        <div class="label label-category">
          <i class="fa fa-folder-open-o"></i>
          {{ category }}
        </div>
      }

      @for (fileNumber of item.file_number; track fileNumber) {
        <div class="label label-filenumber">
          <i class="fa fa-paperclip"></i>
          {{ fileNumber }}
        </div>
      }


      @for (additional of additionals; track additional) {
        <div class="label label-additional">
          <i class="fa fa-tag"></i>
          {{ additional.key }}: {{ additional.value }}
        </div>
      }

    </div>
  </div>
  <div class="document-list-item-action">
    <a [href]="item.web_url" title="Dokument im envisia finder bearbeiten" target="_blank">
      <i class="fa fa-pencil"></i>
    </a>
  </div>
</div>
